<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading d-flex justify-content-between align-items-center">
                <h1>Appeal Events</h1>
            </div>

            <div class="card">
                <p-table #dt [value]="appealEvents" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    [globalFilterFields]="[
                        'caseNumber',
                        'appealCaseNumber',
                        'nda',
                        'brand',
                        'plaintiff',
                        'defendant',
                        'courtName',
                        'appealCourt',
                        'appellant',
                        'appealStatus',
                        'eventName'
                    ]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading" styleClass="appeal-table">

                    <ng-template pTemplate="caption">
                        <div class="d-flex justify-content-end align-items-center w-100">
                            <!-- Date filter + buttons -->
                            <div style="white-space: nowrap;">
                                <label class="mb-0 fw-semibold" style="margin-right: 10px;">
                                    Event Date:
                                </label>

                                <input type="date" class="form-control"
                                    style="max-width: 150px; display: inline-block; margin-right: 10px;"
                                    [(ngModel)]="fromEventDate" name="fromEventDate" />

                                <span style="margin-right: 10px;">to</span>

                                <input type="date" class="form-control"
                                    style="max-width: 150px; display: inline-block; margin-right: 10px;"
                                    [(ngModel)]="toEventDate" name="toEventDate" />

                                <button type="button" class="btn btn-qm-primary btn-sm" style="margin-right: 10px;"
                                    (click)="onApplyEventDateFilter()">
                                    Search
                                </button>

                                <button type="button" class="btn btn-qm-primary btn-sm" style="margin-right: 15px;"
                                    (click)="onClearEventDateFilter()">
                                    Clear
                                </button>
                            </div>

                            <!-- Global search box -->
                            <span class="p-input-icon-left" style="margin-left: 5px;">
                                <input pInputText type="text" placeholder="Search..."
                                    (input)="dt.filterGlobal($event.target.value, 'contains')" />
                            </span>
                        </div>
                    </ng-template>

                    <!-- Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="caseNumber">
                                <span class="header-container">
                                    Case Number
                                    <p-sortIcon field="caseNumber"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="appealCaseNumber">
                                <span class="header-container">
                                    Appeal Case Number
                                    <p-sortIcon field="appealCaseNumber"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="nda">
                                <span class="header-container">
                                    NDA
                                    <p-sortIcon field="nda"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="brand">
                                <span class="header-container">
                                    Brand
                                    <p-sortIcon field="brand"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="plaintiff">
                                <span class="header-container">
                                    Plaintiff
                                    <p-sortIcon field="plaintiff"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="defendant">
                                <span class="header-container">
                                    Defendant
                                    <p-sortIcon field="defendant"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="courtName">
                                <span class="header-container">
                                    Court Name
                                    <p-sortIcon field="courtName"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="appealCourt">
                                <span class="header-container">
                                    Appeal Court
                                    <p-sortIcon field="appealCourt"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="appellant">
                                <span class="header-container">
                                    Appellant
                                    <p-sortIcon field="appellant"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="appealStatus">
                                <span class="header-container">
                                    Appeal Status
                                    <p-sortIcon field="appealStatus"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="eventName">
                                <span class="header-container">
                                    Event Name
                                    <p-sortIcon field="eventName"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="eventDate">
                                <span class="header-container">
                                    Event Date
                                    <p-sortIcon field="eventDate"></p-sortIcon>
                                </span>
                            </th>
                        </tr>
                    </ng-template>

                    <!-- Body -->
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.caseNumber }}</td>
                            <td>{{ row.appealCaseNumber }}</td>
                            <td>{{ row.nda }}</td>
                            <td>{{ row.brand }}</td>
                            <td>{{ row.plaintiff }}</td>
                            <td>{{ row.defendant }}</td>
                            <td>{{ row.courtName }}</td>
                            <td>{{ row.appealCourt }}</td>
                            <td>{{ row.appellant }}</td>
                            <td>{{ row.appealStatus }}</td>
                            <td>{{ row.eventName }}</td>
                            <td>{{ row.eventDate }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>